import React, { useState } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { Box, Button, FormControl, Text, Checkbox } from '@chakra-ui/react';
import { Modal, Textarea } from 'shared-components';

import { ApplicationState } from '../../../../store';
import { getDisplayName } from '../../../../utilities/formatting';
import { IMessage } from 'api-paths-cas';

export interface IProps {
  fieldId: string;
  optionId: string;
  hideSendToStudent?: boolean;
  onSubmit: (message: IMessage) => void;
  onClose: () => void;
}

const UpdateConflictModal = (props: IProps) => {
  const { fieldId, optionId, hideSendToStudent, onSubmit, onClose } = props;
  const [note, setNote] = useState('');
  const [isSendToStudent, setIsSendToStudent] = useState(false);

  const { auth, config, student } = useSelector(
    ({ auth, config, student }: ApplicationState) => ({ auth, config, student }),
    shallowEqual,
  );

  const userName = auth.student_number!;
  const displayName = getDisplayName(auth, config);

  const submit = () => {
    const author = userName || 'Anonymous';
    const message: IMessage = {
      message: `CAS Checklist Updated${note ? `: ${note}` : ''}`,
      createdAt: Date.now(),
      isSendToStudent,
      messageType: 'note',
      author,
      authorName: displayName || author,
      messageFrom: 'uni',
      messageTo: 'uni',
    };

    onSubmit(message);
    onClose();
  };

  const isCourseRelease = fieldId === 'courses' && optionId === 'release';

  return (
    <Modal
      id="update-conflict"
      show={true}
      title={isCourseRelease ? 'Release Student' : 'Keep Value'}
      onClose={onClose}
      footer={
        <Button id="submit-log-button" onClick={submit} variant="solid" size="lg">
          Submit
        </Button>
      }
    >
      {isCourseRelease ? (
        <>
          <Text>Note: Please ensure you have resolved all course and tuition fee conflicts before you submit.</Text>
          <Text>The student will be emailed a link to resume their CAS request from the course page.</Text>
        </>
      ) : (
        <Text>
          Note:{' '}
          {config?.pathwayIds?.length ? student.config.resolveConflictsModalText : config.resolveConflictsModalText}
        </Text>
      )}

      <FormControl size="lg" mb={6}>
        <Textarea
          id={'message'}
          label="Add note (optional)"
          value={note}
          onChange={(event: React.FormEvent<HTMLTextAreaElement>) => setNote(event.currentTarget.value)}
        />
      </FormControl>

      {!hideSendToStudent && (
        <Box>
          <Checkbox isChecked={isSendToStudent} onChange={() => setIsSendToStudent(!isSendToStudent)} size="lg">
            Send this note to student
          </Checkbox>
        </Box>
      )}
    </Modal>
  );
};

export default UpdateConflictModal;
